export default "__VITE_ASSET__BNS1ndzn__"